import { Divider } from '@ksyos/design-system';
import type { IOrthOV1ProcedureProps } from './OrthOV1ProcedureRead';
import { CircleCountHeading } from '../../../elements/CircleCountHeading';
import { OrthOExaminationOrder } from './orthOExaminationOrder';
import { OrthOV1Procedure30cm6mMeasurements } from './OrthOV1Procedure30cm6mMeasurements';
import { ReadOrEditInputField } from './ReadOrEditInputField';

export function OrthOV1ProcedureOcularAlignment(props: IOrthOV1ProcedureProps) {
    return (
        <>
            <CircleCountHeading
                count="1"
                label="Oogstand"
            />
            <ReadOrEditInputField
                {...props}
                error={props.errors?.get('customControlData.algemene_observatie_gezicht')}
                fieldKey="algemene_observatie_gezicht"
                hasErrors={props.errors?.has('customControlData.algemene_observatie_gezicht')}
                isRequired={true}
                label="orthOProcedure.general_observation_face"
                placeholder="Bevindingen..."
                tabIndex={OrthOExaminationOrder.ocularAlignmentExamination}
                value={props.customControlData.algemene_observatie_gezicht}
            />

            <ReadOrEditInputField
                {...props}
                error={props.errors?.get('customControlData.lichtreflex')}
                fieldKey="lichtreflex"
                hasErrors={props.errors?.has('customControlData.lichtreflex')}
                isRequired={!props.isOrthOFol}
                label="orthOProcedure.light_reflex"
                placeholder="Bevindingen..."
                tabIndex={OrthOExaminationOrder.ocularAlignmentExamination}
                value={props.customControlData.lichtreflex}
            />

            <OrthOV1Procedure30cm6mMeasurements
                errors={props.errors}
                field="covertest"
                hasErrors={
                    props.errors?.has('customControlData.covertest_30cm') ||
                    props.errors?.has('customControlData.covertest_6m')
                }
                isReadOnly={props.isReadOnly}
                isRequired
                label="Covertest"
                tabIndex={OrthOExaminationOrder.ocularAlignmentExamination}
                value_30={props.customControlData.covertest_30cm}
                value_6={props.customControlData.covertest_6m}
            />

            <OrthOV1Procedure30cm6mMeasurements
                errors={props.errors}
                field="prismacovertest"
                isReadOnly={props.isReadOnly}
                label="Prismacovertest"
                tabIndex={OrthOExaminationOrder.ocularAlignmentExamination}
                value_30={props.customControlData.prismacovertest_30cm}
                value_6={props.customControlData.prismacovertest_6m}
            />

            <Divider
                color="minimal"
                spacing="medium"
            />
        </>
    );
}
